<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div class="display-4 mb-4">Clash For Win（推荐）</div>
            <ul>
              <li>系统要求：Windows 7 及以上（64-bit）</li>
            </ul>
            <div class="display-4 mt-4 mb-4">介绍</div>
            <p>Clash For Win是个适用于V2Ray的图形化客户端，内核Clash整合了V2Ray，并具有强大的路由功能。本站目前支持Clash的订阅托管模式</p>

            <p>版本:v0.19.21 | 更新日期: 2022-06-24</p>
            <p>
              <a
                href="https://staticn.oss-cn-beijing.aliyuncs.com/clashwin/0.19.21/Clash.for.Windows.Setup.0.19.21.exe"
                target="_blank"
              >本地下载</a> |
              <a
                href="https://github.com/Fndroid/clash_for_windows_pkg/releases/download/0.19.21/Clash.for.Windows.Setup.0.19.21.exe"
                target="_blank"
              >官方下载</a>
              |
              <a
                href="https://staticn.oss-cn-beijing.aliyuncs.com/clashwin/0.19.5/Clash.for.Windows.Setup.0.19.5.ia32.exe"
                target="_blank"
              >32位官方下载</a>
            </p>
            <!-- <h2 id="运行">运行</h2>
            <ul>
              <li>将您下载的压缩包解压到任意目录，建议放在非系统盘的目录里，避免带来权限问题。</li>
              <li>
                运行其中的
                <code>Clash for Windows.exe</code>
              </li>
              <li>Windows 10 第一次运行可能会提示被阻止，点击更多信息」 - 「仍要运行」</li>
            </ul>
            <h2 id="配置订阅并开启clash">配置订阅并开启Clash</h2> -->
            <div class="display-4 mt-4 mb-4">订阅信息</div>
            <div v-if="accounts.length">
              <div v-for="account in accounts" :key="account._id" class="sub-item mb-2">
                <div class="display-6 mt-2 mb-2">{{ account.product.title }}</div>
                <base-button class=" mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_1}/v1/api/clash/${account.subscription || account._id }`, $event)" >点我复制订阅连接1</base-button>
                <base-button size="sm" type="primary" @click="handleCopy(`${subLinks_2}/v1/api/clash/${account.subscription || account._id }`, $event)" >点我复制订阅连接2</base-button>
              </div>
            </div>
            <div v-else>
              <h2 class="display-4" style="font-size: 1.2rem">
                你还没有套餐，
                <router-link :to="{name: 'dashboard-plan'}">立即购买</router-link>
              </h2>
            </div>
            <div class="display-4 mt-4 mb-4">订阅设置</div>
            <!-- <ul>
              <li>
                进入您的
                <a href="https://sstz.info" target="_blank">产品中心</a>，点击对应套餐进入套餐详情，用户信息区域，订阅区域点击
                <strong>Clash订阅链。</strong>
              </li>
            </ul> -->
            <!-- <p>
              <img src="/img/client/pc.png" alt >
            </p> -->
            <!-- <p>
              <img src="/img/client/win/clash/01.png" alt >
            </p> -->
            <ul>
              <li>点击上面的按钮，复制订阅连接</li>
              <li>打开Clash For Windows，点击Profiles，在Download remote configuration file粘贴刚才复制的订阅链，然后点击Download</li>
            </ul>
            <p>
              <img src="/img/client/win/clash/03.png" alt >
            </p>
            <ul>
              <li>下载完成后，上方会多出一个订阅卡片，点击该卡片启用该订阅</li>
            </ul>
            <p>
              <img src="/img/client/win/clash/04.png" alt >
            </p>
            <ul>
              <li>然后点击Proxies，能看到所有节点已经导入，点击卡片选择节点</li>
              <li>
                点击Proxies，能看到所有节点已经导入，点击卡片选择节点，并且在模式中选择：
                <ul>
                  <li>全局模式：所有流量都经过加速服务器</li>
                  <li>规则模式：只有海外流量会经过加速服务器，并且包含了部分去广告去隐私跟规则</li>
                  <li>直连模式：所有流量都不经过加速服务器</li>
                </ul>
              </li>
              <li>规则模式规则已整合在订阅中，使用的是目前效果较好的lhie1规则，每7天服务器会自动更新一次。感谢lhie1大佬维护</li>
            </ul>
            <p>
              <img src="/img/client/win/clash/05.png" alt >
            </p>
            <ul>
              <li>展开服务器列表后，点击雷电按钮，测试线路延迟</li>
            </ul>
            <p>
              <img src="/img/client/win/clash/06.png" alt >
            </p>
            <p>
              <img src="/img/client/win/clash/07.png" alt >
            </p>
            <ul>
              <li>最后点击General，可以看到目前配置信息，勾选System Proxy开启系统代理</li>
            </ul>
            <p>
              <img src="/img/client/win/clash/08.png" alt >
            </p>
            <p>
              <img src="/img/client/win/clash/09.png" alt >
            </p>
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    }
  }

}
</script>
<style scoped>
.search-noresults img {
  max-width: 100%;
}
/* @media only screen and (min-width: 600px) {
 .search-noresults img {
    max-width: 100%;
  }
} */
@media only screen and (min-width: 768px) {
  .search-noresults img {
    max-width: 80%;
  }
}
</style>
